<template>
  <div>
    <el-dialog
      title="Create Teacher Account"
      :visible.sync="dialogCreateVisibleProp"
      width="80%"
      :append-to-body="true"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="postForm" :model="postForm" :rules="rules" label-width="140px" class="demo-ruleForm">
        <div class="createPost-main-container">
          <el-row>
            <el-col :span="24">
              <el-form-item label="Country:" style="margin-bottom: 20px;" prop="country">
                <el-select v-model="postForm.country">
                  <el-option
                    v-for="item in $parent.countries"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Name:" style="margin-bottom: 30px;" prop="name">
                <el-input v-model="postForm.name" style="width:50%;" class="filter-item" placeholder="Name" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Password:" style="margin-bottom: 40px;" prop="password">
                <el-input
                  :key="passwordType"
                  ref="password"
                  v-model="postForm.password"
                  style="width:50%;"
                  :type="passwordType"
                  placeholder="Password"
                  tabindex="2"
                  autocomplete="on"
                  @keyup.native="checkCapslock"
                  @blur="capsTooltip = false"
                />
                <span class="show-pwd" @click="showPwd">
                  <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Confrim Password:" style="margin-bottom: 40px;" prop="confirmPassword">
                <el-input
                  :key="passwordType"
                  ref="confrimpassword"
                  v-model="postForm.confirmPassword"
                  style="width:50%;"
                  :type="passwordType"
                  placeholder="Confrim Password"
                  tabindex="2"
                  autocomplete="on"
                  @keyup.native="checkCapslock"
                  @blur="capsTooltip = false"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Email:" style="margin-bottom: 30px;" prop="email">
                <el-input v-model="postForm.email" style="width:50%;" class="filter-item" placeholder="Email" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Phone:" style="margin-bottom: 30px;" prop="phone">
                <el-input v-model="postForm.phone" style="width:80%;" class="filter-item" placeholder="Phone" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Status:" style="margin-bottom: 20px;" prop="disabled">
                <el-select v-model="postForm.disabled">
                  <el-option
                    v-for="item in disableOpitons"
                    :key="item.value"
                    :label="item.label | uppercaseFirst"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button @click="handleClose()">Cancel</el-button>
                <el-button type="danger" @click="onCreateEvent($event)">Create</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import UserResource from '@/api/user'
const userResource = new UserResource()

const defaultForm = {
  number: '',
  name: '',
  password: '',
  confirmPassword: '',
  email: '',
  phone: '',
  country: 999,
  disabled: 1
}
export default {
  name: 'CreateDialog',
  props: {
    dialogCreateVisibleProp: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    const validateName = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('Name filed is required.'))
      } else {
        if (value.length > 128) {
          callback(new Error('Reached maximum number of characters(128).'))
        } else {
          callback()
        }
      }
    }
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Phone filed is required.'))
      } else {
        callback()
      }
    }
    const validateEmail = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('Email filed is required.'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        if (this.isEdit) {
          if (value === this.postForm.confirmPassword) {
            callback()
          } else {
            callback(new Error('Confirm password and password do not match'))
          }
        } else {
          callback(new Error('Password filed is required.'))
        }
      } else {
        if (this.postForm.confirmPassword.length !== 0) {
          if (value === this.postForm.confirmPassword) {
            callback()
          } else {
            callback(new Error('Confirm password and password do not match'))
          }
        } else {
          callback()
        }
      }
    }
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        if (this.isEdit) {
          if (value === this.postForm.password) {
            callback()
          } else {
            callback(new Error('Confirm password and password do not match'))
          }
        } else {
          callback(new Error('Confrim Password filed is required.'))
        }
      } else {
        if (this.postForm.password.length !== 0) {
          if (value === this.postForm.password) {
            callback()
          } else {
            callback(new Error('Confirm password and password do not match'))
          }
        } else {
          callback()
        }
      }
    }
    return {
      postForm: Object.assign({}, defaultForm),
      disableOpitons: [
        { 'value': 0, 'label': '正常' },
        { 'value': 1, 'label': '封鎖' }
      ],
      passwordType: 'password',
      rules: {
        name: [{ validator: validateName }],
        phone: [{ validator: validatePhone }],
        email: [{ validator: validateEmail }],
        password: [{ validator: validatePassword, trigger: 'blur' }],
        confirmPassword: [{ validator: validateConfirmPassword, trigger: 'blur' }]
      }
    }
  },
  methods: {
    checkCapslock({ shiftKey, key } = {}) {
      if (key && key.length === 1) {
        if (shiftKey && (key >= 'a' && key <= 'z') || !shiftKey && (key >= 'A' && key <= 'Z')) {
          this.capsTooltip = true
        } else {
          this.capsTooltip = false
        }
      }
      if (key === 'CapsLock' && this.capsTooltip === true) {
        this.capsTooltip = false
      }
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    onCreateEvent(event) {
      this.$refs.postForm.validate(valid => {
        if (!valid) {
          return false
        }
        this.sendData()
      })
    },
    async sendData() {
      const { data } = await userResource.createTeacher(this.postForm)
      const actionTitle = 'Create Teacher '
      if (data.code === 0) {
        this.$parent.dialogCreateVisible = false
        this.reloadParentData()
        this.$parent.messageNotify(
          actionTitle + this.$parent.errorCodeMessage[data.code]['title'],
          this.$parent.errorCodeMessage[data.code]['message'],
          this.$parent.errorCodeMessage[data.code]['type']
        )
      } else {
        this.$parent.messageNotify(
          actionTitle + this.$parent.errorCodeMessage[data.code]['title'],
          this.$parent.errorCodeMessage[data.code]['message'],
          this.$parent.errorCodeMessage[data.code]['type']
        )
        return false
      }
    },
    handleClose(done) {
      this.$confirm('Are you sure to close this window?', 'Tip', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(() => {
        this.resetData()
        this.$parent.dialogCreateVisible = false
      }).catch(() => {
        return false
      })
    },
    reloadParentData() {
      this.$parent.getList()
      this.resetData()
    },
    resetData() {
      this.$refs.postForm.resetFields()
    }
  }
}
</script>
